import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import { i18n } from './i18n/i18n';
import '@/utils/rem.js';

import IndustryList from '@/components/Industry.vue';

import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/base.css'
import './assets/css/product_set.scss'
import './assets/css/scene_set.scss'
import './assets/css/industry_set.scss'

Vue.use(ElementUI, { size: 'small', zIndex: 3000 }); // 声明使用ElementUI
// 注册全局组件
Vue.component('industry-list', IndustryList);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
